<template>
  <layout>
    <div slot="content">
      <i-card :title="isEdit ? '编辑合同模板' : '新增合同模板'">
        <el-button slot="right-menu" type="warning" size="small" :loading="loadingDefault" @click="fillDefaultTemplate">填入默认模板</el-button>
        <div slot="content">
          <el-row :gutter="20">
            <!-- 左侧：表单 + 编辑器 -->
            <el-col :span="18">
              <el-form :model="form" label-width="100px" size="small">
                <el-form-item label="模板名称" required>
                  <el-input v-model="form.name" placeholder="请输入合同模板名称" />
                </el-form-item>
                <el-form-item label="备注">
                  <el-input v-model="form.remark" placeholder="备注说明（选填）" />
                </el-form-item>
                <el-form-item label="状态">
                  <el-radio-group v-model="form.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="电子章图片">
                  <i-upload v-model="form.sealImages" :max-files="1" />
                  <div class="form-tip">选填；可用变量 {{seal_image}} 插入到合同任意位置，未使用该变量时默认追加在末尾</div>
                </el-form-item>
                <el-form-item label="合同内容" required>
                  <el-alert
                    title="提示：点击右侧变量按钮可将变量插入到编辑器光标位置，渲染时会自动替换为订单真实数据。"
                    type="info"
                    :closable="false"
                    show-icon
                    style="margin-bottom: 8px"
                  />
                  <i-contract-editor
                    ref="contractEditor"
                    v-model="form.content"
                    :min-height="480"
                    placeholder="请在此编写合同模板内容，可插入右侧变量..."
                  />
                </el-form-item>
              </el-form>

              <div style="text-align: center; margin-top: 24px">
                <el-button @click="goBack">取 消</el-button>
                <el-button type="primary" :loading="saving" @click="handleSave">保 存</el-button>
              </div>
            </el-col>

            <!-- 右侧：变量面板 -->
            <el-col :span="6">
              <div class="variable-panel" v-loading="loadingVars">
                <div class="panel-title">
                  <i class="el-icon-magic-stick"></i> 可用变量
                  <span class="panel-tip">（点击插入到编辑器）</span>
                </div>
                <div class="var-list">
                  <div
                    v-for="v in variables"
                    :key="v.key"
                    class="var-item"
                    @click="insertVariable(v)"
                  >
                    <div class="var-key">{{ varTag(v.key) }}</div>
                    <div class="var-label">{{ v.label }}</div>
                    <div class="var-desc">{{ v.desc }}</div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
import layout from '@/components/layout'
import iCard from '@/components/i-card'
import iContractEditor from '@/components/i-contract-editor'

export default {
  name: 'contract-form',
  components: { layout, iCard, iContractEditor },
  data() {
    return {
      isEdit: false,
      saving: false,
      loadingVars: false,
      loadingDefault: false,
      variables: [],
      form: {
        id: null,
        name: '',
        remark: '',
        status: 1,
        content: '',
        sealImages: [],
      },
    }
  },
  methods: {
    stripVariableDecorations(html) {
      if (!html) return html
      let out = html
      for (let i = 0; i < 6; i++) {
        const next = out.replace(
          /<(span|strong|b)\b[^>]*>(\s*\{\{[^{}]+\}\}\s*)<\/\1>/gi,
          '$2'
        )
        if (next === out) break
        out = next
      }
      return out
    },
    insertVariable(variable) {
      const tag = `{{${variable.key}}}`
      const blockVars = ['traveler_list', 'order_detail_table', 'goods_detail']
      let html
      if (variable.key === 'seal_image') {
        if (!this.form.sealImages[0] || !this.form.sealImages[0].path) {
          this.$message.warning('请先在上方上传电子章图片，渲染时将显示实际图片')
        }
        html = `<span style="display:inline-block;vertical-align:top;line-height:0">${tag}</span>`
      } else if (blockVars.indexOf(variable.key) !== -1) {
        html = `<div style="margin:8px 0">${tag}</div>`
      } else {
        html = tag
      }
      this.$refs.contractEditor.insertHtml(html)
      this.$message.success(`已插入：${tag}`)
    },
    loadVariables() {
      this.loadingVars = true
      this.$http.request('contractVariableList').then(res => {
        this.loadingVars = false
        if (res && res.data) {
          this.variables = res.data
        }
      }).catch(() => {
        this.loadingVars = false
      })
    },
    loadTemplate(id) {
      this.$http.request('getContractTemplate', { id }).then(res => {
        if (res && res.data) {
          const t = res.data
          const content = this.stripVariableDecorations(t.content || '')
          this.form = {
            id: t.id,
            name: t.name,
            remark: t.remark || '',
            status: t.status,
            content,
            sealImages: t.seal_image
              ? [{ path: t.seal_image, file_url: t.seal_image_url || '' }]
              : [],
          }
          this.$nextTick(() => {
            if (this.$refs.contractEditor && content !== t.content) {
              this.$refs.contractEditor.setHtml(content)
            }
          })
        }
      })
    },
    handleSave() {
      if (!this.form.name.trim()) {
        this.$message.error('请填写模板名称')
        return
      }
      // 从编辑器获取最新内容
      let content = this.$refs.contractEditor ? this.$refs.contractEditor.getHtml() : this.form.content
      content = this.stripVariableDecorations(content)
      if (!content || content === '<p><br></p>') {
        this.$message.error('请填写合同内容')
        return
      }
      this.form.content = content
      this.saving = true

      const payload = Object.assign({}, this.form, {
        seal_image: (this.form.sealImages[0] && this.form.sealImages[0].path) ? this.form.sealImages[0].path : '',
      })
      delete payload.sealImages

      const api = this.isEdit ? 'editContractTemplate' : 'addContractTemplate'
      this.$http.request(api, payload).then(res => {
        this.saving = false
        if (res && res.status === 'success') {
          this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
          this.goBack()
        }
      }).catch(() => {
        this.saving = false
      })
    },
    fillDefaultTemplate() {
      this.$confirm('填入默认模板将覆盖当前编辑器内容，是否继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确认填入',
        cancelButtonText: '取消',
      }).then(() => {
        this.loadingDefault = true
        this.$http.request('getContractDefaultTemplate').then(res => {
          this.loadingDefault = false
          if (res && res.data && res.data.content) {
            this.$refs.contractEditor.setHtml(res.data.content)
            this.$message.success('已填入默认合同模板')
          }
        }).catch(() => {
          this.loadingDefault = false
          this.$message.error('获取默认模板失败')
        })
      }).catch(() => {})
    },
    varTag(key) {
      return '{{' + key + '}}'
    },
    goBack() {
      this.$router.push({ name: 'contract.template_list' })
    },
  },
  mounted() {
    this.loadVariables()
    const id = this.$route.query.id
    if (id) {
      this.isEdit = true
      this.loadTemplate(id)
    }
  },
}
</script>

<style scoped>
.variable-panel {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  background: #fafafa;
  padding: 12px;
  position: sticky;
  top: 20px;
}

.panel-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.panel-tip {
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}

.var-list {
  max-height: 580px;
  overflow-y: auto;
}

.var-item {
  padding: 8px 10px;
  margin-bottom: 6px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.var-item:hover {
  border-color: #409eff;
  background: #ecf5ff;
}

.var-key {
  font-size: 12px;
  font-family: monospace;
  color: #e6700d;
  font-weight: bold;
  margin-bottom: 2px;
}

.var-label {
  font-size: 13px;
  color: #303133;
}

.var-desc {
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/contract/contract-form.vue